import { useGetLojaAtualQuery } from '../api';
import { ehDispositivoFixo, ehTotem } from '../lib/canal';
import { useKioskDispositivo } from '../lib/kiosk-dispositivo';

/**
 * Ativa o kiosk "soft" (tela cheia, wake lock, travas de gesto e orientação)
 * quando a loja atual é um dispositivo fixo — TOTEM ou TABLET. Não renderiza nada.
 *
 * O totem ficava de fora (o gate era só `ehTablet`), e por isso rodava em janela
 * com a barra do Windows à mostra.
 */
export function KioskDispositivo(): null {
  const { data } = useGetLojaAtualQuery();
  const identificador = data?.identificador;
  useKioskDispositivo(
    !!identificador && ehDispositivoFixo(identificador),
    identificador && ehTotem(identificador) ? 'portrait' : 'landscape',
  );
  return null;
}
